import { FC, useState } from 'react';
import { CloseButton } from '@cb/apricot-react';

import AttachFileIcon from '@mui/icons-material/AttachFile';

import { IMaterial } from 'src/types';
import { WordBreak } from 'src/components';
import { formatDate, getFileLink } from 'src/utils';

interface IFileDetails {
  data: IMaterial;
  readOnly?: boolean;
  onRemove: (item: IMaterial) => void;
}

const useFileLink = (data: IMaterial) => {
  const [presigned, setPresigned] = useState<string | undefined>(data.preSigned);

  const getPresigned = async () => {
    setPresigned(await getFileLink(data));
  };

  if (!presigned) {
    getPresigned();
  }

  return presigned;
};

export const FileDetails: FC<IFileDetails> = ({ data, readOnly, onRemove }) => {
  const presigned = useFileLink(data);

  return <li className="display-flex align-items-xs-center" key={data.fileName + data.time + (data.fieldPath || 'nofield')}>
    <AttachFileIcon />
    <div>
      <a className="cb-link-blue cb-link-default" href={presigned} target="_blank" rel="noreferrer">
        {data.fileName}
      </a>
      <WordBreak>
        <WordBreak>{data.description}</WordBreak>
        <WordBreak>Uploaded: {formatDate(data.time)}</WordBreak>
      </WordBreak>
    </div>
    <div>
      {!readOnly &&
        <CloseButton style={{ marginLeft: 8 }} onClick={(e) => { onRemove(data); }} />
      }
    </div>
  </li>;
};